import { Button, styled, alpha, TableCell, TableRow } from '@mui/material';

export const RootStyled = styled('div')({
  padding: 19,
  paddingBottom: 34,
});

export const BtnStyled = styled(Button)({
  height: 40,
});

export const BtnSecondaryStyled = styled(Button)(({ theme }) => ({
  height: 40,
  color: theme.palette.global.white,
  fontFamily: theme.typography.button,
}));

export const DefaultPageStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: 100,
  '& p': {
    color: theme.palette.global.lightgray,
    marginBottom: 50,
  },
}));

export const TableCellHeaderStyled = styled(TableCell)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.global.white,
  fontWeight: 600,
  fontSize: '12px',
}));

export const TableRowBodyStyled = styled(TableRow)(({ theme }) => ({
  '& td': {
    borderBottomWidth: 0,
  },
  '&.primary-item': {
    backgroundColor: alpha(theme.palette.primary.main, 0.7),
  },
  '&.secondary-item': {
    backgroundColor: alpha(theme.palette.primary.main, 0.3),
  },
  '&.tertiary-item': {
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
  },
}));
